import React from "react";
import Error from "pages/common/error";

/**
 * 파일명: ErrorBoundary.jsx
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 공통 에러 처리
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: "",
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.toString() };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error);
    console.log(errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <Error msg={this.state.errorMessage} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
